/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.cvsAdmin.ts
 *
 * Messages de l'écran « Les CV déposés » (/admin/cvs). Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-09-27
 */
export const messagesCvsAdminFr: Record<string, string> = {
  'adminNav.cvs': 'CV déposés',
  'acces.titre.adminCvs': 'CV déposés',

  'cvsAdmin.titre': 'Les CV déposés',
  'cvsAdmin.sousTitre':
    'Tous les CV déposés par les personnes inscrites. Cliquez sur le nom du fichier pour l’ouvrir. Chaque ouverture est inscrite au journal de l’organisation.',
  'cvsAdmin.stat.total': 'CV déposés',
  'cvsAdmin.stat.scanned': 'Visibles par les entreprises qui les scannent',
  'cvsAdmin.stat.premium': 'Visibles aussi par les entreprises premium',
  'cvsAdmin.stat.all': 'Visibles par toutes les entreprises',

  'cvsAdmin.recherche.label': 'Rechercher une personne ou un fichier',
  'cvsAdmin.recherche.placeholder': 'Nom, prénom, adresse e-mail, nom du fichier…',
  'cvsAdmin.recherche.cta': 'Rechercher',

  'cvsAdmin.chargement': 'Lecture des CV…',
  'cvsAdmin.erreur': 'Impossible de lire la liste des CV. Réessayez dans un instant.',
  'cvsAdmin.aucunCv': 'Aucun CV déposé pour le moment.',
  'cvsAdmin.aucunResultat': 'Aucun CV ne correspond à cette recherche.',
  'cvsAdmin.tableau.legende': '{n, plural, one {# CV} other {# CV}}',

  'cvsAdmin.col.personne': 'Personne',
  'cvsAdmin.col.recherche': 'Ce qu’elle recherche',
  'cvsAdmin.col.cv': 'Son CV',
  'cvsAdmin.col.visibilite': 'Visible par',
  'cvsAdmin.col.depose': 'Déposé le',
  'cvsAdmin.telecharger': 'Télécharger',
  'cvsAdmin.mineur': 'mineur·e',

  'cvsAdmin.visibilite.scanned': 'Les entreprises qui la scannent',
  'cvsAdmin.visibilite.premium': 'Les entreprises qui la scannent, et les premium',
  'cvsAdmin.visibilite.all': 'Toutes les entreprises exposantes',
  'cvsAdmin.visibilite.none': 'Aucune entreprise',

  'cvsAdmin.recherche.emploi': 'Un emploi',
  'cvsAdmin.recherche.alternance': 'Une alternance',
  'cvsAdmin.recherche.stage': 'Un stage',
  'cvsAdmin.recherche.formation': 'Une formation',
  'cvsAdmin.recherche.information': 'S’informe seulement',
  'cvsAdmin.recherche.non': 'Rien de précis',

  'cvsAdmin.experience.debutant': 'Débutant·e',
  'cvsAdmin.experience.intermediaire': 'Intermédiaire (1 à 3 ans)',
  'cvsAdmin.experience.confirme': 'Confirmé·e (3 à 10 ans)',
  'cvsAdmin.experience.expert': 'Expert·e (10 ans et plus)',

  'cvsAdmin.note':
    'La colonne « Visible par » dit ce que chaque personne a accepté vis-à-vis des entreprises. L’organisation voit tous les CV, parce que c’est à elle qu’ils sont remis ; avant d’en transmettre un à une entreprise, vérifiez ce que la personne a accepté.',
};
